// extracted by mini-css-extract-plugin
export var actionButton = "_s5-0";
export var actionMenuContainer = "_s5-i";
export var bubble = "_s5-2";
export var bubbleActionMenu = "_s5-j";
export var bubbleContext = "_s5-6";
export var bubbleItems = "_s5-7";
export var customer = "_s5-3";
export var divider = "_s5-8";
export var fileList = "_s5-9";
export var hiddenComment = "_s5-o";
export var infoAbove = "_s5-a";
export var internal = "_s5-4";
export var lightActionButton = "_s5-1";
export var link = "_s5-b";
export var merchant = "_s5-5";
export var message = "_s5-c";
export var profilePicture = "_s5-e";
export var quillToolbarContainer = "_s5-f";
export var senderDate = "_s5-g";
export var senderDateCustomer = "_s5-h";
export var senderName = "_s5-d";
export var time = "_s5-k";
export var uploadedImage = "_s5-l";
export var username = "_s5-m";
export var xsmall = "_s5-n";